export class ContextSignals {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get context() {
        return this.parent;
    }
    signalValueOf(signalName) {
        const found = this.context.actor.local.traitsOf.signal.find(trait => trait.value === signalName);
        /*
        if (found && traitRegistry.getRegByKey(signalName)) {
          return found.local.valueOf[signalName];
        }
    */
        if (found && found.local.valueOf.signalValue) {
            return found.local.valueOf.signalValue;
        }
        if (this.context.parentActor) {
            return this.context.parentActor.context.contextSignals.signalValueOf(signalName);
        }
        return '';
    }
}
